import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "stage", "input" ]
  static values = { url: String }

  connect() {
    if (this.urlValue !== "") this._showEmbed(this.urlValue)
    if (this.hasInputTarget && this.inputTarget.value !== "") this._showEmbed(this.inputTarget.value)
  }

  onChange(event) {
    const target = event.currentTarget

    console.log("dasdsa")
    console.log(target.checkValidity())

    if (target.checkValidity()) {
      this._showEmbed(target.value)
    } else {
      if (this.hasStageTarget) this.stageTarget.innerHTML = ""
    }
  }

  _showEmbed(url) {
    if (!this.hasStageTarget) return

    this._doEmbedForUrl(url)
  }

  _getUrlComponents(url) {
    const protocols = new RegExp('^(https?:\/\/)')
    if (!protocols.test(url)) url = `https://${url}`
    return new URL(url)
  }

  _doEmbed(url) {
    const iframe = `
      <iframe src="${url}" class="embed-viewer" frameBorder="0" allow="accelerometer; autoplay; picture-in-picture" allowFullscreen="true"></iframe>
    `
    this.stageTarget.innerHTML = iframe
  }

  _doEmbedForUrl(url) {
    url = this._getUrlComponents(url)

    if (this._isYouTube(url)) {
      this._doEmbed(this._embedForYouTube(url))
    } else if (this._isVimeo(url)) {
      this._doEmbed(this._embedForVimeo(url))
    }
  }

  _isYouTube(url) {
    return /youtu/.test(url.host)
  }

  _isVimeo(url) {
    return /vimeo/.test(url.host)
  }

  _embedForYouTube(url) {
    let videoID = url.searchParams.get('v')
    if (!videoID) videoID = url.pathname.slice(1)
    return `https://www.youtube.com/embed/${videoID}`
  }

  _embedForVimeo(url) {
    return `https://player.vimeo.com/video/${url.pathname.slice(1)}`
  }
}
